<template>
  <modal
    style="z-index:1060;"
    width="80%"
    height="80%"
    name="term-of-use-modal"
  >
    <button
      @click="hide('term-of-use-modal')"
      style="margin:5% 5%; cursor:pointer"
      class="pull-right"
    >
      <span class="mdi mdi-alpha-x-circle"></span>
    </button>
    <div class="faq-section spad">
      <div class="container">
        <div v-html="content"></div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      content: "",
      // type: "terms_of_use",
      type: "privacy_policy",
      name: "Condition d'utilisation",
      loader: false,
    };
  },
  beforeMount() {
    this.getPageType(this.type);
  },
  methods: {
    hide(modalName) {
      this.$modal.hide(modalName);
    },
    getPageType(type) {
      this.$axios({
        url: "page/" + type,
        method: "GET",
      })
        .then((response) => {
          if (response.data.length > 0) {
            this.content = response.data[0].content;
            this.id = response.data[0].id;
          }
        })
        .catch(function(err) {
          console.log(err.response.data);
        });
    },
  },
  computed: {},
};
</script>
